import { render, staticRenderFns } from "./literacyStudies.vue?vue&type=template&id=d320104a&scoped=true&"
import script from "./literacyStudies.vue?vue&type=script&lang=js&"
export * from "./literacyStudies.vue?vue&type=script&lang=js&"
import style0 from "./literacyStudies.vue?vue&type=style&index=0&id=d320104a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d320104a",
  null
  
)

export default component.exports